import { render, staticRenderFns } from "./AdditionalOptions.vue?vue&type=template&id=ccf10082&scoped=true&"
import script from "./AdditionalOptions.vue?vue&type=script&lang=ts&"
export * from "./AdditionalOptions.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalOptions.vue?vue&type=style&index=0&id=ccf10082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf10082",
  null
  
)

component.options.__file = "AdditionalOptions.vue"
export default component.exports